<template src="shared/modules/seo/seo-text.html" />
<script>
/* istanbul ignore file */

export default {
  name: 'SeoTextContent',
};
</script>
